import { useGettingStartedTasks } from '../store'
import { OnboardingTask, TaskSkeleton } from './task'

export const GetStarted = () => {
	const tasks = useGettingStartedTasks()

	if (!tasks) return null

	return (
		<div className="border-input flex flex-col gap-8 rounded-lg border p-4 sm:gap-4">
			<div>
				<h2 className="text-xl font-semibold">Get Started</h2>
				<p className="text-muted-foreground text-sm">
					Complete these steps to configure your security dashboard
				</p>
			</div>

			{Object.values(tasks)
				.sort((a, b) => a.order - b.order)
				.map((task) => (
					<OnboardingTask
						key={task.id}
						index={task.order}
						task={task}
						link={task.link}
					/>
				))}
		</div>
	)
}

export const GetStartedSkeleton = () => {
	return (
		<div className="border-input flex flex-col gap-8 rounded-lg border p-4 sm:gap-4">
			<div>
				<h2 className="text-xl font-semibold">Get Started</h2>
				<p className="text-muted-foreground text-sm">
					Complete these steps to configure your security dashboard
				</p>
			</div>

			{Array.from({ length: 7 }).map((_, index) => (
				<TaskSkeleton key={index} />
			))}
		</div>
	)
}
